import { WEBCODE_REQUESTED } from "./const";

function action() {
  return {
    type: WEBCODE_REQUESTED,
  };
}

export default action;
